import React, { useRef } from 'react'
import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextField } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useMemoryBook } from '../../../../../providers/MemoryBookProvider'

export default function CaptionOverlay({
  overlay,
  pageNumber,
  positionIndex,
  captionState = '',
  textFieldOnChange,
  titleState = '',
  titleFieldOnChange,
  isHeading = false,
  titleText,
}) {
  const [t] = useTranslation()
  const { updatePageContent } = useMemoryBook() || {}
  const saveOnclick = async () => {
    await updatePageContent(pageNumber, positionIndex, {
      caption: captionState,
      title: titleState,
    })
    overlay.close()
  }
  const textRef = useRef()

  return (
    <DialogOverlay title={titleText} {...overlay} focusRef={textRef}>
      <TextField
        label={isHeading ? t('CaptionOverlay.title.label', 'Title') : t('CaptionOverlay.caption.label', 'Caption')}
        value={isHeading ? titleState : captionState}
        onChange={isHeading ? titleFieldOnChange : textFieldOnChange}
        maxLength={!isHeading ? 70 : 50}
        ref={textRef}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            saveOnclick()
          }
        }}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={overlay.close}>{t('common-ui:cancel.action', 'Cancel')}</Button>
          <Button onClick={saveOnclick} type="submit" emphasis="high">
            {t('common-ui:save.action', 'Save')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
